export const formatNumber = (value, fractionDigits = 2) => {
    if (typeof value === 'number') {
        return value.toLocaleString('pt-BR', {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        });
    }

    return value;
};
